import React, { FunctionComponent } from "react";
import { useQuery } from "@tanstack/react-query";
import { AsyncTextCellParams } from "../types/data-table.types";
import { TextCellContents } from "./text-cell-renderer";

/**
 * Used as cellRenderer for data table column of type "text"
 */
export const AsyncTextCell: FunctionComponent<AsyncTextCellParams> = ({ getAsyncValue, value }) => {
    const { data: displayValue } = useQuery(["async-text-cell", value], () => getAsyncValue(value));
    return <TextCellContents valid>{displayValue ?? <span>Loading...</span>}</TextCellContents>;
};
